(function($) {
	
	'use strict';
	var formValidator;
	var subscriptionUpdate;
	var emailInput;
	
	var submitForm = function (e) {
		var btn = $(this);
        var form = btn.closest('form');
		
        if (btn.hasClass('disabled')) {
            return false;
        }

        btn.addClass('disabled');
		formValidator.validateForm(form);

		if (form.hasClass('has-error')) {
			formValidator.showErrorPopup();
            btn.removeClass('disabled');
            grecaptcha.reset(btn.attr('data-widget-id'));
			return false;
		}
		
        if (form.hasClass('checkout-form')) {
            validateEmail(
                function() {
                    fbq('track', 'CompleteRegistration');
                    form.find('.select-state-input-ctn:not(.selected)').remove();
                    form[0].submit();
                }, 
                function() {
                    form.addClass('has-error');
                    btn.removeClass('disabled');
                    grecaptcha.reset(btn.attr('data-widget-id'));
                }
            );
        } else {
            form[0].submit();
        }
	};

	var addToCart = function() {
		var btn = $(this);
		var tabCtn = btn.closest('.tab-ctn');
		var packages = tabCtn.find('.packages-outer-ctn');
		var formCtn = tabCtn.find('.registration-form-ctn');
		var productId = btn.attr('data-id');
		var url = '/action/shopAddCart';

		btn.addClass('disabled');

        // Clear cart
		ajax(url + '?clear=true&ajax=true', function() {
            // Add product
			ajax(url + '?ajax=true&quantity=1&productId=' + productId, function(response) {
				btn.removeClass('disabled');
				if (response.indexOf('success') !== -1) {
					btn.addClass('clear');
					packages.slideUp();
					formCtn.slideDown(function() {
						var target = formCtn.offset().top - $('.site-header').height();

						$('html').animate({scrollTop: target});
						$('body').animate({scrollTop: target});
						updateCartRecap(formCtn);
					});
					
					$('.register-ctn').nextAll().slideUp();
				}
			}, true);
        }, true);
	};

	var validateEmail = function(successCallback, errorCallback) {
		$.ajax("/action/validateUsername", {
			data: "username=" + encodeURIComponent(emailInput.val()),
			success: function(res) {
				if (res.trim() === "success") {
					if (typeof successCallback === 'function') {
						successCallback();
					}
				} else {
					if (typeof errorCallback === 'function') {
						errorCallback();
					}
		   			formValidator.showErrorPopup('email-error');
					emailInput.removeClass('success').addClass('error')
						.closest('.form-input-big-ctn').removeClass('success').addClass('error');
				}
			},
			error: function() {
				//Something went wrong with the internet or server.
			}
		});
	};

	var goBackToPackages = function() {
		var btn = $(this);
		var tabCtn = btn.closest('.tab-ctn');
		var packages = tabCtn.find('.packages-outer-ctn');
		var formCtn = tabCtn.find('.registration-form-ctn');

		ajax('/action/shopAddCart?clear=true&ajax=true', function(response) {
			formCtn.slideUp();
			formCtn.find('.form-select[name=subscription-length]').val(1);
			packages.slideDown();
			$('.register-ctn').nextAll().slideDown();
		}, true);
	};

	var applyPromoCode = function() {
		var t = $(this);
		var form = t.closest('form');
		var input = $('input[name=code]', form);
		var inputCtn = input.closest('.form-input-big-ctn');
		var success = inputCtn.find('.form-success-message.promo-success.plan');
		var error = inputCtn.find('.form-error-message.promo-invalid');
		var code = input.val();

		if (code !== '') {		
			ajax('/action/shopApplyPromo?code=' + code + '&ajax=true', function(response) {
				inputCtn.removeClass('success error');
				error.slideUp();
				success.slideUp();

				if (response.indexOf('plan rebate') !== -1) {
					inputCtn.addClass('success');
					success.slideDown();
				} else if (response.indexOf('invalid') !== -1) {
					input.val('');
					inputCtn.addClass('error');
					error.slideDown();
				}

				if (t.closest('.user-subscription-modif-form').length > 0) {
					subscriptionUpdate.updateSubscriptionRecap(form);
				} else {
					updateCartRecap(t.closest('.registration-form-ctn'));
				}
			}, true);
		}
	};

	var updateCartRecap = function(ctn) {
		var country = "CA";
		var state = "QC";
		if(ctn.find(".select-country-input").val() !== ''){
			country = ctn.find(".select-country-input").val();
		}
		if(ctn.find(".select-state-input.selected").val() !== ''){
			state = ctn.find(".select-state-input.selected").val();
		}
		var url = "/action/shopJsonCart";
		if(country !== ""){
			url += "?country=" + country;
		}
		if(state !== ""){
			if(country === ""){
				url += "?";
			} else {
				url += "&";
			}
			url += "state=" + state;
		}
		ajax(url, function(response) {
			var json = JSON.parse(response);
			var dot = $('html').attr('lang') === 'fr' ? ',' : '.';

			$('.registration-form-ctn').attr('data-id', json[0][0].id);

            ctn.find('.codename.tax1-recap').html(json[1].tax1Name + ": ");
            ctn.find('.codename.tax2-recap').html(json[1].tax2Name + ": ");
			ctn.find('.amount.subtotal-recap').html(json[0][0].price);
			ctn.find('.amount.tax1-recap').html((json[1].hasOwnProperty("futureTax1")) ? json[1].futureTax1 : json[1].TPS);
			ctn.find('.amount.tax2-recap').html((json[1].hasOwnProperty("futureTax2")) ? json[1].futureTax2 : json[1].TVQ);
			ctn.find('.amount.later-recap').html((json[1].hasOwnProperty("futureTotal")) ? json[1].futureTotal : json[0][0].realPrice);
			ctn.find('.amount.total-recap').html(json[1].total);
			if (json[0][0].price > json[0][0].realPrice) {
				ctn.find('.yearly-plan-percent-off-recap').html($('.yearly-plan-percent-off[data-id=' + json[0][0].productId + ']').html());
				ctn.find('.yearly-plan-percent-off-ctn').slideDown();
			} else {
				ctn.find('.yearly-plan-percent-off-recap').html('');
				ctn.find('.yearly-plan-percent-off-ctn').slideUp();
			}
            if (json[0][0].addTextField3.toLowerCase() === 'non' && json[0][0].addTextField4.toLowerCase() === 'non') {
                ctn.find('.checkbox-understand-basic-plan').show()
                    .find('.form-check-input').addClass('required').prop('checked', false);
            } else {
                ctn.find('.checkbox-understand-basic-plan').hide()
                    .find('.form-check-input').removeClass('required').prop('checked', false);
            }

			// if (json[1].promoValue !== undefined) {
			// 	ctn.find('.promo-code-recap').html(json[1].promoValue);
			// 	ctn.find('.promo-code-code').html(json[1].promoCode);
			// 	ctn.find('.promo-code-discount-val').html(json[1].discountValue);
			// 	$('.promo-code-extra').slideDown();
			// } else {
			// 	ctn.find('.promo-code-recap').html('0' + dot + '00');
			// 	ctn.find('.promo-code-code').html('');
			// 	ctn.find('.promo-code-discount-val').html('');
			// 	$('.promo-code-extra').slideUp();
			// }
		}, true);
	};

	var changePlan = function() {
		var t = $(this);

		ajax('/action/shopAddCart?productId=' + t.closest('.registration-form-ctn').attr('data-id') + '&override=true&quantity=' + t.val() + '&ajax=true', function(response) {
			updateCartRecap(t.closest('.registration-form-ctn'));
		}, true);
	};
    
    var preventDefault = function(e) {
        e.preventDefault();
    };
	
	var init = function (e) {
		formValidator = Fw.component.models().form;
		subscriptionUpdate = Fw.page.models().subscriptionUpdate;
		emailInput = $('input[name="userEmail"]');
		
		var checkoutForm = $('.checkout-form');
        var registerForm = $('.register-form');
        
        checkoutForm.on('submit', preventDefault);
        checkoutForm.find('.buy-package-btn').each(function(i, el) {
            Fw.component.models().utils.recaptcha2(el, submitForm);
        });
        
        registerForm.on('submit', preventDefault);
        registerForm.find('.form-btn-ctn button').each(function(i, el) {
            Fw.component.models().utils.recaptcha2(el, submitForm);
        });
        
		$('.add-to-cart-btn').click(addToCart);
		$('.back-to-packages-btn').click(goBackToPackages);
		$('.package-cat-tab-btn').click(function() {
			$('.back-to-packages-btn').each(function() {
				$(this).trigger('click');
			});
		});
		$('.apply-promo-code-btn').click(applyPromoCode);
		$('.form-select[name="subscription-length"]').change(changePlan);
		
		$(".select-country-input", checkoutForm).on("change", function () {
			updateCartRecap(checkoutForm);
		});
		$(".select-state-input.selected", checkoutForm).on("change", function () {
			updateCartRecap(checkoutForm);
		});

		emailInput.focusout(validateEmail);

		if ($('div[id^="stripe-cc-form"]').length) {
			$('div[id^="stripe-cc-form"]').each(function() {
				Fw.component.models().stripeToken.init($(this));
			});
		}
	};
	
	$(window).ready(init);
	
})(jQuery);
